import strings from 'owa-strings/owa-mini-people-strings';
import { FoldersSectionTreeData } from '../schema/FoldersSectionTreeData';
import { format } from 'owa-strings/utilities/format';
import { getIconClassName } from '@uifabric/styling';
import { MiniIcons } from 'owa-mini-icons';
import { PeopleIcons } from 'mini-people-icons';
import { PeopleRouteType } from 'mini-people-route-store';

export function getDefaultFoldersSectionTreeData(
    location: PeopleRouteType,
    onFolderClick: (routeType: PeopleRouteType) => void
): FoldersSectionTreeData {
    const nodeIds = ['contacts', 'contactlists'];
    const isYourContactsSelected = location === PeopleRouteType.Contact;
    const isYourContactListSelected = location === PeopleRouteType.ContactList;

    return {
        nodeIds: nodeIds,
        folders: {
            contacts: {
                displayName: strings.yourContactsFolderLabel,
                isExpanded: false,
                isSelected: isYourContactsSelected,
                onClick: () => onFolderClick(PeopleRouteType.Contact),
                iconProps: {
                    iconName: getIconClassName(MiniIcons.Contact),
                    getChevronIconAriaLabel: (isExpanded: boolean, displayName: string) =>
                        displayName,
                },
                ariaLabelForNode: isYourContactsSelected
                    ? format(strings.selectedFolderAriaLabel, strings.yourContactsFolderLabel)
                    : strings.yourContactsFolderLabel,
            },
            contactlists: {
                displayName: strings.contactListsFolderLabel,
                isExpanded: false,
                isSelected: isYourContactListSelected,
                onClick: () => onFolderClick(PeopleRouteType.ContactList),
                iconProps: {
                    iconName: getIconClassName(PeopleIcons.ContactList),
                    getChevronIconAriaLabel: (isExpanded: boolean, displayName: string) =>
                        displayName,
                },
                ariaLabelForNode: isYourContactListSelected
                    ? format(strings.selectedFolderAriaLabel, strings.contactListsFolderLabel)
                    : strings.contactListsFolderLabel,
            },
        },
    };
}
